import PropTypes from 'prop-types';
import { useState } from 'react';
import { ArrowLink, Modal, PromotionBadge } from '@bwoty-web/ui-kit';

import RoomGroupRow from './RoomGroupRow';
import FlightDetails from '../shared/flightDetails/FlightDetails';
import SkipLink from '../shared/skipLink/SkipLink';
import { urlUtils } from '../../utils/url';

import './priceMatrixTable.scss';

const PriceMatrixTable = ({
  getFlightTime,
  hotel = null,
  labels,
  selectRoomGroup,
  showRoomTypeLink = false,
  transport = null,
}) => {
  const { homeBoundFlights, outBoundFlights, flightTimeInformation } = transport;
  const [isFlightInformationOpen, setIsFlightInformationOpen] = useState(false);
  const isCombination = urlUtils.isCombination();

  const showFlightInformationPopup = () => {
    if (!flightTimeInformation) {
      getFlightTime();
    }

    setIsFlightInformationOpen(true);
  };

  const renderFlightInfoPopUp = () => {
    return (
      <Modal
        heading={labels.FlightDetailsLink}
        isOpen={isFlightInformationOpen}
        onClose={() => setIsFlightInformationOpen(false)}
      >
        <FlightDetails
          flights={[outBoundFlights[0], homeBoundFlights[0]]}
          flightTimeInformation={flightTimeInformation}
          labels={labels}
        />
      </Modal>
    );
  };

  const renderDepartureCell = () => {
    const { departureDateDay, departureDateDayName, departureDateMonthName, departureTime } = outBoundFlights[0];

    return (
      <div className="price-matrix-table__header-row">
        <div className="price-matrix-table__header heading-h2">{labels.ChooseRoomType}</div>
        <div className="price-matrix-table__right-column price-matrix-table__departure-info">
          <div className="price-matrix-table__departure-top-container">
            <div className="price-matrix-table__departure-day">{departureDateDay}</div>
            <div className="price-matrix-table__departure-weekday-month">
              <div className="price-matrix-table__departure-month">{departureDateMonthName.toUpperCase()}</div>
              <div className="price-matrix-table__departure-weekday">{departureDateDayName.toUpperCase()}</div>
            </div>
          </div>
          <div className="price-matrix-table__departure-time">{departureTime}</div>
          <ArrowLink
            data-gtm-tag="Flight Info"
            className="price-matrix-table__flight-info-link"
            onClick={showFlightInformationPopup}
          >
            {labels.FlightDetailsLink}
          </ArrowLink>
        </div>
      </div>
    );
  };

  const renderRoomGroupRows = () => {
    const roomGroupRows = hotel.roomGroups.map((roomGroup, i) => {
      return (
        <RoomGroupRow
          key={roomGroup.bookingEngineRoomGroupKey}
          keyIndex={i}
          labels={labels}
          roomGroup={roomGroup}
          selectedRoomGroup={hotel.selectedRoomGroup}
          selectRoomGroup={selectRoomGroup}
          showRoomTypeLink={showRoomTypeLink}
        />
      );
    });
    return roomGroupRows;
  };

  return (
    <div className="uikit-box price-matrix-table__container">
      <SkipLink
        href="#price-summary"
        linkText={labels?.skipRoomListLabel}
        className="price-matrix-table__skiplink"
      />
      <div className="price-matrix-table">
        {hotel?.promoLabel && (
          <PromotionBadge
            className="price-matrix-table__promotion-badge"
            layout="TagFullWidth"
            promotion={hotel?.promoLabel?.text}
            type={hotel?.promoLabel?.promotionType}
            urgency={hotel?.promoLabel?.urgency}
          />
        )}
        {!isCombination && renderDepartureCell()}
        {renderFlightInfoPopUp()}
        {renderRoomGroupRows()}
      </div>
      <div className="price-matrix-table_price-info-text">{labels.priceInfoText}</div>
    </div>
  );
};

PriceMatrixTable.propTypes = {
  hotel: PropTypes.shape({
    selectedRoomGroup: PropTypes.shape({}),
    roomGroups: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  transport: PropTypes.shape({
    homeBoundFlights: PropTypes.arrayOf(
      PropTypes.shape({
        bookingEngineKey: PropTypes.string,
      }),
    ).isRequired,
    outBoundFlights: PropTypes.arrayOf(
      PropTypes.shape({
        departureDateDay: PropTypes.string,
        departureDateMonthName: PropTypes.string,
        departureDateDayName: PropTypes.string,
        departureTime: PropTypes.string,
        bookingEngineKey: PropTypes.string,
      }),
    ).isRequired,
    flightTimeInformation: PropTypes.shape({}),
  }),
  labels: PropTypes.shape({
    priceInfoText: PropTypes.string,
    ChooseRoomType: PropTypes.string,
    FlightDetailsLink: PropTypes.string,
    skipRoomListLabel: PropTypes.string,
  }).isRequired,
  selectRoomGroup: PropTypes.func.isRequired,
  getFlightTime: PropTypes.func.isRequired,
  showRoomTypeLink: PropTypes.bool,
};

export default PriceMatrixTable;
